import SelectGrid, { SelectGridItem } from "../components/selectGrid/SelectGrid";
import { POSOnboardSetup } from "../useApplyOnboardSetup";
import "./style.scss";
import "./step-fonts.scss";
import { Font } from "@common/build/types";
import availableFonts from "../../../fonts/availableFonts";
import { Dispatch, SetStateAction, useState, useCallback } from "react";
import { IconTitle } from "../components/smallComponents/IconTitle";
import OliverText from "@builder/components/general/OliverText";

interface StepFontsProps {
    posOnboardSetup: POSOnboardSetup;
    setPOSOnboardSetup: Dispatch<SetStateAction<POSOnboardSetup>>;
}

const SingleFont = ({ font }: { font: Font }) => {
    const sampleStyle: React.CSSProperties = {
        fontFamily: font.name,
    };
    return (
        <div className="font-preview">
            <OliverText size="xxs" weight="light">
                {font.name}
            </OliverText>
            <span className="font-heading" style={sampleStyle}>
                Heading
            </span>
            <span className="font-paragraph" style={sampleStyle}>
                This is your paragraph
            </span>
        </div>
    );
};

const StepFonts = ({ posOnboardSetup, setPOSOnboardSetup }: StepFontsProps) => {
    const [searchInput, setSearchInput] = useState<string>("");

    const filteredFonts = searchInput
        ? availableFonts.filter(font =>
              font.name.replace(/\s+/g, "").toLowerCase().includes(searchInput.replace(/\s+/g, "").toLowerCase())
          )
        : availableFonts;

    const items: SelectGridItem[] = filteredFonts.map(font => ({
        id: font.name,
        Node: <SingleFont key={font.name} font={font} />,
    }));

    const handleSelect = useCallback(
        (id: string) => {
            setPOSOnboardSetup(prev => ({
                ...prev,
                selectedFontName: id,
            }));
        },
        [setPOSOnboardSetup]
    );

    const handleSearchInput = (e: React.FormEvent<HTMLInputElement>) => {
        setSearchInput(e.currentTarget.value);
    };

    return (
        <div className="single-onboard-step">
            <IconTitle iconUrl="/square-text-1.svg" title="Select your font combination" />

            <div className="fonts-search">
                <div className="search-wrapper">
                    <img className="search" src="/search-icon.svg" alt="search" />
                    {searchInput && (
                        <button onClick={() => setSearchInput("")}>
                            <img className="cancel" src="/x-icon-dark.svg" alt="clear" />
                        </button>
                    )}
                    <input type="text" value={searchInput} placeholder="Search fonts" onInput={handleSearchInput} />
                </div>
            </div>

            <SelectGrid items={items} selectedId={posOnboardSetup.selectedFontName} onSelect={handleSelect} />
        </div>
    );
};

export default StepFonts;
